import { Injectable } from "@angular/core";
import { CONTROLLERS, ENDPOINTS } from "src/app/constants";
import { ApiService } from "../api.service";
import { PaymentsDashboardReqCommand, PaymentAnalyticsListResp, Response, PaymentMethodListResp, CCPaymentTrendsListResp, OverallTrendsListResp, OverallPaymentSnapshotResp, PlaymentActionRequiredResponse } from "src/app/models";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class PaymentDashboardService {
    private api: string = CONTROLLERS.TENANTS.PAYMENT_DASHBOARD;
    private apiPayment:string = CONTROLLERS.PAYMENTS.PAYMENT;
    constructor(private apiService: ApiService) { }

    getPaymentAnalytics(
        PaymentsDashboardReqCommand: PaymentsDashboardReqCommand
    ): Observable<Response<PaymentAnalyticsListResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENT_DASHBOARD.PAYMENT_ANALYTICS}`,
            PaymentsDashboardReqCommand
        );
    }

    getPaymentMethod(PaymentsDashboardReqCommand: PaymentsDashboardReqCommand): Observable<Response<PaymentMethodListResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENT_DASHBOARD.PAYMENT_METHOD}`,
            PaymentsDashboardReqCommand
        );
    }

    getCCPaymentTrends(PaymentsDashboardReqCommand: PaymentsDashboardReqCommand): Observable<Response<CCPaymentTrendsListResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENT_DASHBOARD.CCPAYMENTTREDS}`,
            PaymentsDashboardReqCommand
        );
    }
    getOverallTrends(PaymentsDashboardReqCommand: PaymentsDashboardReqCommand): Observable<Response<OverallTrendsListResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENT_DASHBOARD.OVERALL_TRENDS}`,
            PaymentsDashboardReqCommand
        );
    }

    getOverallPaymentSnapshot(PaymentsDashboardReqCommand: PaymentsDashboardReqCommand): Observable<Response<OverallPaymentSnapshotResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENT_DASHBOARD.OVERALL_PAYMENT_SNAPSHOT}`,
            PaymentsDashboardReqCommand
        );
    }
    
    getActionRequired(practiceId: number): Observable<Response<PlaymentActionRequiredResponse>> {
        const url = `${ENDPOINTS.PAYMENTS.PAYMENT.GET_ACTION_REQUIRED}?practiceId=${practiceId}`;
        return this.apiService.get(`${this.apiPayment}/${url}`);
    }

}
